export const VERIFIED_STATUS = {
    VERIFYING: "VERIFYING",
    VERIFIED: "VERIFIED",
    FAILED: "FAILED"
};
